import { decodeStringKey, encodeStringKey } from '../common/utils';
import { ClassifierMappingSearchResultType } from './types';

export const encodeClassifierMappingOptionValue = (
  classifierMapping: ClassifierMappingSearchResultType,
) =>
  encodeStringKey(
    'classifier-mapping',
    classifierMapping.id,
    classifierMapping.code,
    classifierMapping.name,
  );

export const decodeClassifierMappingOptionValue = (value: string) => {
  const [, id, code, name] = decodeStringKey(value);
  return {
    classifierMappingId: Number(id),
    classifierMappingCode: code,
    classifierMappingName: name,
  };
};
